import PropTypes from 'prop-types';
import React from 'react';
import Collapsible from 'react-collapsible';

import style from './Accordion.module.scss';

const Accordion = ({
  openIconName,
  closedIconName,
  trigger,
  isOpened,
  transitionTime,
  children,
  elKey,
  triggerDisabled,
}) => {
  const className = 'c-Accordion';

  const collapsibleClassName = `${className}__collapse`;

  const getCollapsibleClassName = isOpen => {
    const collapsibleClassNames = `${collapsibleClassName} ${
      style[collapsibleClassName]
    } ${
      style[
        `${collapsibleClassName}__${isOpen ? openIconName : closedIconName}`
      ]
    }`;
    const collapsibleCloseClassName = `${className}__collapse-close`;
    return `${collapsibleClassNames} ${collapsibleCloseClassName} ${style[collapsibleCloseClassName]}`;
  };

  return (
    <div className={className}>
      <Collapsible
        transitionTime={transitionTime}
        openedClassName={getCollapsibleClassName(true)}
        className={getCollapsibleClassName(false)}
        trigger={trigger}
        key={elKey}
        triggerDisabled={triggerDisabled}
        open={isOpened}
      >
        {children}
      </Collapsible>
    </div>
  );
};

Accordion.defaultProps = {
  openIconName: 'arrow',
  closedIconName: 'arrow',
};

Accordion.propTypes = {
  openIconName: PropTypes.string,
  closedIconName: PropTypes.string,
  trigger: PropTypes.object, // Collapsible trigger
  isOpened: PropTypes.bool,
  transitionTime: PropTypes.number,
  children: PropTypes.object, //Collapsible inner content
  elKey: PropTypes.number,
  triggerDisabled: PropTypes.bool,
};

export default Accordion;
